export default __webpack_public_path__ + "static/media/besties.398f40d1.webp";